import { CryptoSwapsService } from "../services/cryptoSwaps.service";
import type { OtcOrder } from "../types/cryptoSwaps.types";
import { useSelectedOtcOrder, type UseSelectedOtcOrderResult } from "./useSelectedOtcOrder";

export type UseSelectedCryptoSwapResult = UseSelectedOtcOrderResult<OtcOrder>;

const fetchOrder = (orderId: string) => CryptoSwapsService.getOrder(orderId);

/** The purchase the history's `?order=` points at. */
export function useSelectedCryptoSwap(orderId: string | null, rows: OtcOrder[]): UseSelectedCryptoSwapResult {
  return useSelectedOtcOrder(orderId, rows, fetchOrder);
}
